export const IMAGES = {
    CONTENTS: {
        ONLINE: '/images/pay.jpg',
        intro: '/images/download.jpg',
        ARROW_DOWN: '/images/down-dotted-arrow.svg',
        ARROW_DOWN_CURVED: '/images/arrow-down-curved.svg'
    },
    ICONS: {
        EDIT: '/images/edit-icon.svg',
        LOCK: '/images/lock.svg',
        CONFIRM: '/images/confirm-icon.svg',
        DELETE: '/images/trash.svg',
        CANCEL: '/images/cancel-icon.svg',
        ADD: '/images/add-icon.svg',
        DOWNLOAD: '/images/download-icon.svg',
        BACK: '/images/back-icon.svg',
        GOOGLE: '/images/google.svg',
        LOGO_DARK: '/images/logo-dark.svg',
        PROFILE: '/images/profile.svg',
        DATABASE: '/images/database.svg',
        TELEGRAM: '/images/telegram.svg',
        ARTICLE: '/images/article.svg',
        LINK: '/images/link.svg',
        USD_FLAG: '/images/usd-flag.jpg',
        CA_FLAG: '/images/ca-flag.jpg',
        EURO_FLAG: '/images/euro-flag.jpg',
        POUND_FLAG: '/images/pound-flag.jpg',
        TETHER_FLAG: '/images/tether-flag.jpg',
    }
}